module.exports = __webpack_public_path__ + "static/media/legionella_off.da9914fc.svg";